import { Button, Separator } from '@chain-zen/ui'
import { toast } from 'sonner'

interface IMcLeodWorkspaceIDSectionProps {
  displayedWorkspaceID: string
  isDFM: boolean
}

/**
 * Displays the McLeod Account ID with copy-to-clipboard functionality.
 * Shows module-type-appropriate instruction text.
 */
export function McLeodWorkspaceIDSection({ displayedWorkspaceID, isDFM }: IMcLeodWorkspaceIDSectionProps) {
  const instructionText = isDFM
    ? 'Copy this McLeod Account ID and add it in the Freight Matching Control'
    : 'Copy this McLeod Account ID and use it with your API module configuration'

  return (
    <>
      <Separator className="my-4" />
      <div className="space-y-2 w-full">
        <p className="text-sm">{instructionText}</p>
        <div className="relative w-full">
          <div className="rounded-md border bg-muted px-3 py-2 font-mono text-sm break-all">
            {displayedWorkspaceID}
            <Button
              variant="ghost"
              size="sm"
              className="ml-2"
              onClick={() => {
                navigator.clipboard.writeText(displayedWorkspaceID)
                toast.success('McLeod Account ID copied to clipboard!')
              }}
            >
              Copy
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
